import {combineReducers} from "redux"
import customizer from "./customizer/"
import auth from "./auth/";
import user from "./user";
import team from "./team";
import taxonomy from "./taxonomy";
import log from "./log";
import supplier from "./supplier";
import dashboard from "./dashboard";
import info_merch from "./info_merch";
import data_merch from "./data_merch";

import navbar from "./navbar/Index"

const appReducer = combineReducers({
  customizer: customizer,
  auth: auth,
  user,
  team,
  log,
  taxonomy,
  supplier,
  dashboard,
  navbar,
  info_merch,
  data_merch
});

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_STORE') return appReducer(undefined, action);
  return appReducer(state, action);
};
export default rootReducer
